import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard, SportGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// raf
const IndexPage = lazy(() => import('src/pages/dashboard/raf-page'));
// ----------------------------------------------------------------------

export const rafRoutes = [
  {
    path: 'raf',
    element: (
      <SportGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </SportGuard>
    ),
    children: [
      {
        element: (
          <AuthGuard>
            <IndexPage />
          </AuthGuard>
        ),
        index: true,
      },
    ],
  },
];
